/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Unit_CreditsInputs */



/**
* | output |
* | --- |
* | "credits" |
*
* @param {Signup_Compare_Unit_CreditsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_unit_credits = /** @type {((inputs?: Signup_Compare_Unit_CreditsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Unit_CreditsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("credits")
	if (locale === "de") return /** @type {LocalizedString} */ ("credits")
	if (locale === "it") return /** @type {LocalizedString} */ ("credits")
	if (locale === "ru") return /** @type {LocalizedString} */ ("credits")
	if (locale === "es") return /** @type {LocalizedString} */ ("credits")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("credits")
	if (locale === "ja") return /** @type {LocalizedString} */ ("credits")
	if (locale === "hi") return /** @type {LocalizedString} */ ("credits")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("credits")
	return /** @type {LocalizedString} */ ("credits")
});